import styled from 'styled-components';
import Icon from '../../assets/images/email-icon.svg';

const EmailIcon = styled.span`
    ${({ fill = '#FD7B7A' }) => `
        background-color: ${fill};
        mask-image: url("${Icon}");
        mask-position: center center;
        mask-repeat: no-repeat;
        mask-size: 100%;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        height: 12px;
        width: 18px;
    `}
}`;

export default EmailIcon;
